import React from 'react'
import useErrorBoundaryCallback from '../../utils/useErrorBoundaryCallback'
import useEventCallback from '../../utils/useEventCallback'
import withMemoByProps from '../../utils/withMemoByProps'
import Marker from './Marker'
import PoiMarkerHTML from './PoiMarkerHTML'
import { useGoToGeoentityTagData } from '../../geoentity/useGoToGeoentityTagData'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import { CLICKED_BUTTON } from '../../analytics/analytics.constants'

const PoiMarker = ({ id, additionalInfo, isCurrent, navigateToPoi, focusPoi, unfocusPoi, poi, ...marker }) => {
  const configureAndSendTag = useConfigureAndSendTag()
  const tagData = useGoToGeoentityTagData(poi, { zone: 'carte', [CLICKED_BUTTON]: 'carte' })

  const onSelect = useErrorBoundaryCallback(() => {
    focusPoi(id)
  }, [focusPoi])

  const onUnselect = useErrorBoundaryCallback(() => {
    unfocusPoi(id)
  }, [unfocusPoi])

  const onClick = useEventCallback(() => {
    configureAndSendTag(tagData)
    navigateToPoi(id)
  }, [tagData, navigateToPoi])

  return (
    <Marker isCurrent={isCurrent} onSelect={onSelect} onUnselect={onUnselect} onClick={onClick} {...marker}>
      <PoiMarkerHTML isCurrent={isCurrent} {...marker} />
    </Marker>
  )
}

export default withMemoByProps(PoiMarker, [
  'isCurrent',
  'additionalInfo.fuels.length',
  'price',
  'priceColor',
  'rubric.id',
  'zIndex'
])
